var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('img',{attrs:{"src":_vm.entry.fields.file.de.url,"height":"100px","width":"100px","contain":""}})]),_c('br'),_vm._v(" "+_vm._s(_vm.entry.sys.id)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }